import React from 'react';
import { produceWithAsync } from "../utils/immerAsync";
import useTaskQueue from "./useTaskQueue";
import * as R from 'unitx/ramda';
import { useStateWithCallback } from "./useStateWithCallback";

/* eslint-enable functional/immutable-data, functional/no-expression-statement */
const CONCURRENCY = 1;
export default ((initialValue, options = {}) => {
  var _options$deps;

  // const {} = config
  const {
    logger
  } = options;
  const [state, setState] = useStateWithCallback({
    refreshCount: 0
  });
  const stateRef = React.useRef({
    value: initialValue,
    updaterReturn: null,
    setState
  });
  stateRef.current.setState = setState;
  React.useMemo(() => {
    stateRef.current.value = initialValue;
  }, (_options$deps = options.deps) !== null && _options$deps !== void 0 ? _options$deps : []); /// CREATE_QUEUE

  const queue = useTaskQueue({
    concurrency: CONCURRENCY
  }); /// ADD_QUEUE

  const updateValueCallback = React.useCallback(async (updater, stateCallback) => {
    queue.push(async () => {
      var _updaterReturn;

      // @ts-ignore
      let updaterReturn = null;
      const nextValue = await produceWithAsync(stateRef.current.value, async draft => {
        // @ts-ignore
        updaterReturn = await updater(draft);
      });
      logger === null || logger === void 0 ? void 0 : logger({
        name: updater.name,
        state: nextValue
      });
      stateRef.current.value = nextValue;
      stateRef.current.updaterReturn = updaterReturn; // @ts-ignore

      if ((_updaterReturn = updaterReturn) === null || _updaterReturn === void 0 ? void 0 : _updaterReturn.silent) {
        stateCallback === null || stateCallback === void 0 ? void 0 : stateCallback(nextValue);
      } else {
        // @ts-ignore
        stateRef.current.setState({
          refreshCount: state.refreshCount + 1
        }, () => stateCallback === null || stateCallback === void 0 ? void 0 : stateCallback(nextValue));
      }
    });
  }, []);
  const setCallback = React.useCallback((nextValue, config) => {
    // @ts-ignore
    updateValueCallback(draft => {
      const {
        current: {
          value
        }
      } = stateRef;
      R.when(R.isPlainObject, () => {
        R.mapObjIndexed((_, key) => {
          // @ts-ignore
          delete draft[key];
        })(value);
        R.mapObjIndexed((val, key) => {
          // @ts-ignore
          draft[key] = val;
        })(nextValue);
      })(value);
      return config;
    });
  }, [updateValueCallback]);
  const clearCallback = React.useCallback(() => {
    setCallback(initialValue);
  }, [updateValueCallback]);
  return [stateRef.current.value, updateValueCallback, {
    updaterReturn: stateRef.current.updaterReturn,
    set: setCallback,
    clear: clearCallback
  }];
});
/* eslint-enable functional/immutable-data, functional/no-expression-statement */
// const silentUpdateValueCallback = React.useCallback(
//   async (
//     updater: Parameters<UpdateStateFunc>[0],
//     stateCallback?: Parameters<UpdateStateFunc>[1]
//   ) => {
//   // queue.push(updater)
//   queue.push(async () => {
//     let updaterReturn = null
//     const nextValue = await produceWithAsync(
//       stateRef.current.state.value, 
//       async (draft: T) => {
//         updaterReturn = await updater(draft)
//       },
//     )
//     logger?.({ name: updater.name, state: nextValue})
//     state.value = nextValue
//     state.updaterReturn = updaterReturn
//     stateRef.current.state = state
//     stateCallback?.(nextValue)
//   })
// }, [state])